export default function SharedWorker_fn() {
  return new SharedWorker(__webpack_public_path__ + "index_60b73ea.worker.js");
}
